module.exports = "/images/gb-sct.svg?085f29d7ca61b196f00580854b9acaa0";